import { T as H } from "./layout-BD1t4ofR.js";
import { n as v } from "./Logger-CmiOOsKC.js";
import { h as V } from "./tracebehavior-5_qSKjs6.js";
import { D as J, b as q, f as K } from "./SceneCreation-DVCYLXYF.js";
import { t as Y } from "./schema-9wLyxyBJ.js";
import { C as Q } from "./AssetTypes-DUDo9FdH.js";
import { r as X } from "./assetRef-BeDJZkjy.js";
import { Quaternion as Z, Vector3 as O } from "@babylonjs/core/Maths/math.vector.js";
import { ImportMeshAsync as ee } from "@babylonjs/core/Loading/sceneLoader.js";
import { TransformNode as te } from "@babylonjs/core/Meshes/transformNode.js";
import { GLTFLoaderAnimationStartMode as ne } from "@babylonjs/loaders/glTF/glTFFileLoader.pure.js";
import { AssetContainer as se } from "@babylonjs/core/assetContainer.js";
function L(e, t) {
  t && (t.translation && (e.position = new O(t.translation[0], t.translation[1], t.translation[2])), t.rotation && (e.rotationQuaternion = new Z(t.rotation[0], t.rotation[1], t.rotation[2], t.rotation[3])), t.scale && (e.scaling = new O(t.scale[0], t.scale[1], t.scale[2])));
}
function re(e, t) {
  const n = e.getChildren();
  if (n.length === 1) {
    const s = n[0];
    return s.parent = t, e.dispose(), s;
  } else
    return e.parent = t, e;
}
function oe(e, t, n) {
  return {
    transform: e,
    name: t,
    assetUri: n
  };
}
function I(e, t, n) {
  const s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  for (const a of e) {
    const u = new te(a.name, t);
    L(u, a.transform), s.set(a, u), o.set(a.name, u), n?.(a, u);
  }
  const r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  for (const a of e) {
    const u = s.get(a);
    if (a.parentName) {
      const l = a.parentName.startsWith("/") ? a.parentName.slice(1) : a.parentName, d = (a.parentNode ? s.get(a.parentNode) : void 0) ?? r.get(l) ?? r.get(a.parentName) ?? o.get(l) ?? o.get(a.parentName);
      d && (u.parent = d);
    }
    const f = a.parentName?.startsWith("/") ? a.parentName.slice(1) : a.parentName, h = (a.parentNode ? i.get(a.parentNode) : void 0) ?? f, c = h ? `${h}/${a.name}` : a.name;
    r.set(c, u), i.set(a, c);
  }
  return {
    nodeTransforms: s,
    pathMap: r,
    nodePaths: i
  };
}
async function ie(e) {
  const { nodes: t, scene: n, onProgress: s, loadAsset: o, extractMetadata: r, createLoadedNode: i = oe } = e, a = [], u = /* @__PURE__ */ new Map(), { nodeTransforms: f, nodePaths: h } = I(t, n), c = t.filter((m) => m.assetUri).length;
  let l = 0;
  const d = [];
  for (const m of t) {
    const b = f.get(m), p = h.get(m), x = i(b, m.name, m.assetUri);
    if (r && r(m, x), m.assetUri) {
      const A = m.assetUri;
      d.push(o(A, b).then((y) => {
        y.meshes.length > 0 && (x.mesh = y.meshes[0]), y.animationGroups.length > 0 && (x.animationGroups = y.animationGroups), y.skeletons.length > 0 && (x.skeletons = y.skeletons), y.extensionsUsed && (x.extensionsUsed = y.extensionsUsed);
      }).catch((y) => {
        v.warn(`Failed to load asset "${A}" for node "${m.name}":`, y instanceof Error ? y.message : String(y)), x.loadError = y instanceof Error ? y.message : String(y);
      }).then(() => {
        l++, s?.({
          lengthComputable: !0,
          loaded: l,
          total: c
        });
      }));
    }
    a.push(x), u.set(p, x);
  }
  return await Promise.all(d), {
    nodes: a,
    rootNodes: a.filter((m) => !m.transform.parent),
    nodeMap: u
  };
}
async function ae(e) {
  const { nodes: t, container: n, scene: s, onProgress: o, loadAsset: r } = e, { nodeTransforms: i } = I(t, s, (c, l) => {
    n.transformNodes.push(l);
  }), a = t.filter((c) => c.assetUri), u = a.length;
  let f = 0;
  const h = await Promise.all(a.map((c) => r(c.assetUri, i.get(c)).catch((l) => (v.warn(`Failed to load asset "${c.assetUri}" for node "${c.name}":`, l instanceof Error ? l.message : String(l)), null)).then((l) => (f++, o?.({
    lengthComputable: !0,
    loaded: f,
    total: u
  }), l))));
  for (const c of h)
    c && (n.meshes.push(...c.meshes), n.animationGroups.push(...c.animationGroups), n.skeletons.push(...c.skeletons));
}
var D = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", ce = 16, Ke = 22;
function le(e) {
  return /^[A-Za-z0-9]+$/.test(e);
}
function Ye() {
  const e = new Uint8Array(ce), t = globalThis.crypto;
  if (!t?.getRandomValues) throw new Error("[uid] crypto.getRandomValues is unavailable — cannot mint a node uid");
  return t.getRandomValues(e), fe(e).padStart(22, "0");
}
function fe(e) {
  const t = Array.from(e), n = [];
  let s = 0;
  for (; s < t.length; ) {
    let r = 0;
    for (let i = s; i < t.length; i++) {
      const a = r * 256 + t[i];
      t[i] = Math.floor(a / 62), r = a % 62;
    }
    for (n.push(r); s < t.length && t[s] === 0; ) s++;
  }
  if (n.length === 0) return D[0];
  let o = "";
  for (let r = n.length - 1; r >= 0; r--) o += D[n[r]];
  return o;
}
var ue = "model/gltf+json", he = "model/gltf-binary", M = 1179937895, B = 1313821514;
function S(e) {
  try {
    if (typeof e == "string") return g(JSON.parse(e));
    const t = me(e);
    if (t) {
      const n = pe(t) ?? new TextDecoder().decode(t);
      return g(JSON.parse(n));
    }
    return g(e);
  } catch {
    return;
  }
}
async function Qe(e) {
  if (e.size >= 20) {
    const n = new Uint8Array(await e.slice(0, 20).arrayBuffer()), s = new DataView(n.buffer, n.byteOffset, n.byteLength);
    if (s.getUint32(0, !0) === M) {
      if (s.getUint32(16, !0) !== B) return;
      const o = s.getUint32(12, !0);
      return S(await e.slice(20, 20 + o).text());
    }
  }
  const t = await e.text();
  if (!(!t.includes('"externalAssets"') && !t.includes('"trace"')))
    return S(t);
}
function me(e) {
  if (e instanceof ArrayBuffer) return new Uint8Array(e);
  if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  const t = e;
  if (t && typeof t == "object" && typeof t.byteLength == "number" && !("buffer" in t)) try {
    return new Uint8Array(t);
  } catch {
    return;
  }
}
function pe(e) {
  if (e.byteLength < 20) return;
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength);
  if (t.getUint32(0, !0) !== M) return;
  const n = t.getUint32(12, !0);
  if (t.getUint32(16, !0) !== B) return;
  const s = Math.min(20 + n, e.byteLength);
  return new TextDecoder().decode(e.subarray(20, s));
}
function g(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e) ? e : void 0;
}
function Xe(e) {
  const t = g(e);
  if (!t) return !1;
  if (Array.isArray(t.externalAssets) && t.externalAssets.length > 0 || T(t.extras)) return !0;
  const n = Array.isArray(t.scenes) ? t.scenes : [];
  for (const s of n) if (T(g(s)?.extras)) return !0;
  return !!(g(t.asset)?.experience === !0 || Array.isArray(t.assets) && t.assets.length > 0 && Array.isArray(t.nodes));
}
function T(e) {
  return !!g(g(e)?.trace);
}
function de(e) {
  const t = S(e);
  if (!t) throw new Error("[normalizeSceneDocument] not a JSON object");
  const n = g(t.asset)?.version;
  return (Array.isArray(t.files) || Array.isArray(t.externalAssets) || typeof n == "string" && n.startsWith("2.1") ? "gltf21" : "glxf") == "gltf21" ? ge(t) : ye(t);
}
function ge(e) {
  const t = (e.files ?? []).map((o) => ({
    uri: o.uri ?? "",
    mimeType: o.mimeType ?? C(o.uri ?? ""),
    ...typeof o.name == "string" && o.name !== "" ? { name: o.name } : {}
  })), n = e.externalAssets ?? [], s = (e.nodes ?? []).map((o, r) => {
    const i = $(o, r);
    if (ve(i, t, r), typeof o.externalAsset == "number") {
      const u = n[o.externalAsset]?.file;
      typeof u == "number" && t[u] && (i.file = u, i.carrier = "externalAsset");
    }
    const a = Y(o.extensions);
    if (a) {
      const u = [...a.problems], f = (a.sources ?? []).flatMap((h, c) => {
        const l = n[h.externalAsset]?.file;
        return typeof l != "number" || !t[l] ? (u.push(`sources[${c}].externalAsset ${h.externalAsset} names no file`), []) : [{
          file: l,
          ...h.root !== void 0 ? { root: h.root } : {}
        }];
      });
      f.length === 0 ? u.push("no source binds") : i.animationBinding = {
        sources: f,
        problems: u
      }, u.length > 0 && v.warn(`[normalizeSceneDocument] node ${r} TRACE_animation_binding: ${u.join("; ")}`);
    }
    if (i.file === void 0) {
      const u = Ae(i.extras);
      u !== void 0 && t[u] && (i.file = u, i.carrier = "trace");
    }
    return i;
  });
  return xe(e.nodes ?? [], s), {
    sourceFormat: "gltf21",
    files: t,
    nodes: s,
    ...k(e.scene, e.scenes),
    ...G(e)
  };
}
function xe(e, t) {
  const n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map();
  for (const i of e)
    typeof i.uid == "string" && i.uid !== "" && n.add(i.uid), typeof i.name == "string" && i.name !== "" && s.set(i.name, (s.get(i.name) ?? 0) + 1);
  const o = /* @__PURE__ */ new Map(), r = (i) => `"${t[i]?.name ?? `node ${i}`}" (node ${i})`;
  for (let i = 0; i < t.length; i++) {
    const a = e[i], u = typeof a?.uid == "string" && a.uid !== "" ? a.uid : void 0;
    if (u) {
      const h = o.get(u);
      if (h !== void 0) {
        v.warn(`[normalizeSceneDocument] duplicate node uid "${u}": ${h} keeps it, ${r(i)} is read as having none and will be minted a new one`);
        continue;
      }
      t[i].uid = u, o.set(u, r(i));
      continue;
    }
    const f = typeof a?.name == "string" ? a.name : "";
    f && le(f) && s.get(f) === 1 && !n.has(f) && !o.has(f) && (t[i].uid = f, o.set(f, r(i)));
  }
}
function ye(e) {
  const t = (e.assets ?? []).map((n) => ({
    uri: n.uri ?? "",
    mimeType: C(n.uri ?? "")
  }));
  return {
    sourceFormat: "glxf",
    files: t,
    nodes: (e.nodes ?? []).map((n, s) => {
      const o = $(n, s);
      return typeof n.asset == "number" && t[n.asset] && (o.file = n.asset, o.carrier = "externalAsset"), o;
    }),
    ...k(e.scene, e.scenes),
    ...G(e)
  };
}
function $(e, t) {
  const n = { name: e.name || `Node_${t}` };
  e.children && (n.children = e.children), e.translation && (n.translation = e.translation), e.rotation && (n.rotation = e.rotation), e.scale && (n.scale = e.scale), e.matrix && (n.matrix = e.matrix);
  const s = g(e.extras);
  s && (n.extras = s);
  const o = g(e.extensions);
  return o && (n.extensions = o), n;
}
function k(e, t) {
  const n = (t ?? []).map((s) => {
    const o = { nodes: s.nodes ?? [] };
    s.name !== void 0 && (o.name = s.name);
    const r = g(s.extras);
    return r && (o.extras = r), o;
  });
  return {
    scene: e ?? 0,
    scenes: n
  };
}
function G(e) {
  const t = {};
  e.extensions && (t.extensions = e.extensions);
  const n = g(e.extras);
  n && (t.extras = n), Array.isArray(e.extensionsUsed) && (t.extensionsUsed = e.extensionsUsed), Array.isArray(e.extensionsRequired) && (t.extensionsRequired = e.extensionsRequired);
  const s = g(e.asset?.extras);
  return s && (t.assetExtras = s), t;
}
var be = (() => {
  const e = /* @__PURE__ */ new Map(), t = (n, s, o) => {
    for (const r of s)
      r.key === "src" && e.set(n, [...e.get(n) ?? [], o]), r.type === "object" && !r.isMap && t(n, r.fields, [...o, r.key]), r.type === "array" && r.itemFields && t(n, r.itemFields, [
        ...o,
        r.key,
        "[]"
      ]);
  };
  for (const n of H) t(n.type, n.fields, []);
  return e;
})();
function ve(e, t, n) {
  const s = g(e.extras?.trace), o = s?.behaviors;
  if (!s || !Array.isArray(o)) return;
  const r = (f) => v.warn(`[normalizeSceneDocument] node ${n}: ${f}`), i = (f) => {
    const h = g(f);
    if (!h || !("file" in h)) return f;
    const { file: c, ...l } = h;
    if ("src" in h)
      return r(`a behavior carries both src and file ${JSON.stringify(c)}; file ignored`), l;
    const d = typeof c == "number" && Number.isInteger(c) ? t[c] : void 0;
    return d?.uri || r(`behavior file ${JSON.stringify(c)} ${d ? "has no uri" : "names no file"}; src read as null`), {
      ...l,
      src: d?.uri || null
    };
  }, a = (f, h, c) => {
    if (h.length === 0) return c(f);
    const [l, ...d] = h;
    if (l === "[]") {
      if (!Array.isArray(f)) return f;
      const p = f.map((x) => a(x, d, c));
      return p.some((x, A) => x !== f[A]) ? p : f;
    }
    const m = g(f);
    if (!m || !(l in m)) return f;
    const b = a(m[l], d, c);
    return b === m[l] ? f : {
      ...m,
      [l]: b
    };
  }, u = o.map((f) => {
    const h = g(f)?.["@type"];
    return ((typeof h == "string" ? be.get(h) : void 0) ?? []).reduce((c, l) => a(c, l, i), f);
  });
  u.some((f, h) => f !== o[h]) && (e.extras = {
    ...e.extras,
    trace: {
      ...s,
      behaviors: u
    }
  });
}
function Ae(e) {
  const t = g(e?.trace)?.file;
  return typeof t == "number" && Number.isInteger(t) && t >= 0 ? t : void 0;
}
function C(e) {
  const t = we(e);
  return t === "gltf" ? ue : t === "glb" ? he : Q(t) ?? "";
}
function we(e) {
  const t = e.split(/[?#]/)[0], n = t.substring(t.lastIndexOf("/") + 1), s = n.lastIndexOf(".");
  return s > 0 ? n.substring(s + 1).toLowerCase() : "";
}
var E = "trace", Ue = ["KHR_interactivity"], Se = ["TRACE_animation_binding"];
function Re(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e) ? e : void 0;
}
function w(e, t) {
  const n = Re(e);
  if (!n) return;
  const s = {};
  let o = !1;
  for (const r of Object.keys(n))
    t.includes(r) || (s[r] = n[r], o = !0);
  return o ? s : void 0;
}
function F(e) {
  return Object.values(e).some((t) => t !== void 0) ? e : void 0;
}
function Ee(e) {
  const t = w(e.extras, [E]), n = w(e.extensions, Se);
  return F({
    ...t ? { extras: t } : {},
    ...n ? { extensions: n } : {}
  });
}
function _e(e) {
  const t = e.scenes[e.scene] ?? e.scenes[0], n = w(e.extras, [E]), s = w(t?.extras, [E]), o = w(e.assetExtras, []), r = w(e.extensions, Ue), i = e.extensionsUsed?.length ? [...e.extensionsUsed] : void 0, a = e.extensionsRequired?.length ? [...e.extensionsRequired] : void 0;
  return F({
    ...n ? { extras: n } : {},
    ...s ? { sceneExtras: s } : {},
    ...o ? { assetExtras: o } : {},
    ...r ? { extensions: r } : {},
    ...i ? { extensionsUsed: i } : {},
    ...a ? { extensionsRequired: a } : {}
  });
}
function Ze(e, t) {
  return e ? {
    ...e,
    ...t ?? {}
  } : t;
}
function j(e) {
  return e.extras?.trace;
}
function z(e, t) {
  e.extras = {
    ...e.extras ?? {},
    trace: t
  };
}
function P(e) {
  return e.extras?.trace;
}
function Ne(e, t) {
  return P(e) || (e.scenes[e.scene] ?? e.scenes[0])?.extras?.trace ? !0 : t.some((n) => j(n) !== void 0);
}
function Oe(e) {
  if (!e) return;
  const t = e.split("?")[0].split("#")[0].replace(/\\/g, "/").split("/").pop();
  if (t)
    return t.replace(/\.[^.]+$/, "") || void 0;
}
function De(e, t) {
  const n = new Set(t.map((o) => o.name));
  if (!n.has(e)) return e;
  let s = 2;
  for (; n.has(`${e}_${s}`); ) s++;
  return `${e}_${s}`;
}
function Te(e, t, n = {}) {
  const s = e.scenes[e.scene] ?? e.scenes[0], o = s?.nodes ?? [], r = s?.extras?.trace, i = P(e), a = i?.scripts ?? r?.scripts;
  if (r && s?.extras) {
    const { trace: c, ...l } = s.extras;
    s.extras = Object.keys(l).length > 0 ? l : void 0;
  }
  if (o.length === 1) {
    const c = t[o[0]];
    if (c)
      return r && Le(c, r), {
        root: c,
        rootIndex: o[0],
        synthesized: !1,
        ...a ? { scripts: a } : {}
      };
  }
  const u = Ne(e, t);
  if (!u && !n.openAsScene) return {
    synthesized: !1,
    ...a ? { scripts: a } : {}
  };
  const f = De(s?.name ?? i?.name ?? Oe(n.fileName) ?? "Scene", t), h = { name: f };
  if (r) {
    const c = {};
    r.behaviors?.length && (c.behaviors = r.behaviors), r.active !== void 0 && (c.active = r.active), Object.keys(c).length > 0 && z(h, c);
  }
  for (const c of o) {
    const l = t[c];
    l && (l.parentName = f, l.parentNode = h);
  }
  return t.unshift(h), v.log(`[documentRoot] ${u ? "a Trace" : "a foreign"} document with ${o.length} root node(s) was normalized to one: "${f}" (SCENE_ROOT_SPEC §3). The next save writes D8 shape.`), {
    root: h,
    synthesized: !0,
    ...a ? { scripts: a } : {}
  };
}
function Le(e, t) {
  const n = j(e) ?? {}, s = [...n.behaviors ?? [], ...t.behaviors ?? []], o = { ...n };
  s.length > 0 && (o.behaviors = s), n.active === void 0 && t.active !== void 0 && (o.active = t.active), z(e, o), (t.behaviors?.length || t.active !== void 0) && v.log(`[documentRoot] folded a pre-D8 scene payload onto "${e.name}" (${t.behaviors?.length ?? 0} behavior(s)) — SCENE_ROOT_SPEC §3.`);
}
var Ie = /* @__PURE__ */ new Set([
  "Model",
  "Image",
  "Video",
  "AudioClip"
]);
function Me(e) {
  const t = W(e);
  return t ? t.some((n) => typeof n["@type"] == "string" && Ie.has(n["@type"])) : !1;
}
function W(e) {
  const t = e?.trace?.behaviors;
  return Array.isArray(t) ? t : void 0;
}
function Be(e) {
  return e.startsWith("http://") || e.startsWith("https://") || e.startsWith("blob:") || e.startsWith("data:");
}
var et = class {
  name = "gltf-scene";
  extensions = { ".glxf": { isBinary: !1 } };
  _blobUrls = [];
  _lastLoadedResult = null;
  _externalAssetLookup = null;
  _openAsScene = !1;
  setExternalAssetLookup(e) {
    this._externalAssetLookup = e;
  }
  setOpenAsScene(e) {
    this._openAsScene = e;
  }
  async loadAsync(e, t, n, s, o) {
    this._blobUrls = [], this._lastLoadedResult = null;
    try {
      const r = await this.parseSceneData(t, n, o);
      this._lastLoadedResult = await this.loadNodesWithResult(r, e, s);
    } finally {
      this.cleanupBlobUrls();
    }
  }
  async importMeshAsync(e, t, n, s, o, r) {
    e != null && v.warn(`${this.name}: meshesNames parameter is ignored. Scene composition formats load complete scene graphs.`);
    const i = new Set(t.meshes), a = new Set(t.animationGroups), u = new Set(t.skeletons), f = new Set(t.transformNodes), h = new Set(t.geometries), c = new Set(t.lights);
    return await this.loadAsync(t, n, s, o, r), {
      meshes: t.meshes.filter((l) => !i.has(l)),
      animationGroups: t.animationGroups.filter((l) => !a.has(l)),
      skeletons: t.skeletons.filter((l) => !u.has(l)),
      transformNodes: t.transformNodes.filter((l) => !f.has(l)),
      geometries: t.geometries.filter((l) => !h.has(l)),
      lights: t.lights.filter((l) => !c.has(l)),
      particleSystems: [],
      spriteManagers: []
    };
  }
  async loadAssetContainerAsync(e, t, n, s, o) {
    const r = new se(e);
    this._blobUrls = [];
    try {
      const i = await this.parseSceneData(t, n, o);
      await this.loadNodesIntoContainer(i, r, e, s);
    } finally {
      this.cleanupBlobUrls();
    }
    return r;
  }
  getLastLoadedResult() {
    return this._lastLoadedResult;
  }
  async loadWithResult(e, t, n, s, o) {
    this._blobUrls = [];
    try {
      const r = await this.parseSceneData(t, n, o), i = s ? (a) => {
        s(a.loaded, a.total);
      } : void 0;
      return await this.loadNodesWithResult(r, e, i);
    } finally {
      this.cleanupBlobUrls();
    }
  }
  async parseSceneData(e, t, n) {
    const s = this.parseDocument(e), o = this.parseDocumentNodes(s, t), r = this.migrateDocumentRoot(s, o, n);
    return this.restoreKHRInteractivity(s, o, r), {
      nodes: o,
      assetBlobUrls: /* @__PURE__ */ new Map(),
      rootUrl: t,
      document: s,
      ...r.root ? { documentRoot: r.root } : {},
      ...r.scripts ? { scripts: r.scripts } : {}
    };
  }
  migrateDocumentRoot(e, t, n) {
    return Te(e, t, {
      ...n ? { fileName: n } : {},
      openAsScene: this._openAsScene
    });
  }
  applyDocumentData(e, t) {
    if (t.scripts && Object.keys(t.scripts).length > 0 && (e.scripts = t.scripts), t.documentRoot) {
      const s = t.nodes.indexOf(t.documentRoot);
      s >= 0 && (e.documentRoot = e.nodes[s]);
    }
    const n = _e(t.document);
    return n && (e.foreignDocument = n), e;
  }
  restoreKHRInteractivity(e, t, n) {
    const s = e.extensions?.KHR_interactivity;
    if (!s?.graphs?.length) return;
    const o = e.scenes[e.scene]?.nodes ?? e.scenes[0]?.nodes ?? [], r = n.root ?? t[o[0]];
    if (!r) return;
    const i = r.extras ?? {}, a = i.trace ?? {}, u = a.behaviors ?? [];
    if (u.some((p) => p["@type"] === "BehaviorGraph")) return;
    const f = e.nodes, h = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
    for (let p = 0; p < f.length; p++) {
      h.set(p, f[p].name);
      const x = f[p].children;
      if (x) for (const A of x) c.set(A, p);
    }
    const l = n.rootIndex ?? f.length;
    if (n.rootIndex === void 0)
      for (const p of o) c.has(p) || c.set(p, l);
    const d = J(s, {
      hostIndex: l,
      nodeCount: f.length,
      nameOf: (p) => p === l ? r.name : h.get(p),
      parentOf: (p) => c.get(p)
    });
    if (d.nodes.length === 0) return;
    const m = q(d), b = m ? {
      "@type": "BehaviorGraph",
      graphs: m.graphs,
      activeGraph: m.activeGraph
    } : {
      "@type": "BehaviorGraph",
      graph: d
    };
    r.extras = {
      ...i,
      trace: {
        ...a,
        behaviors: [...u, b]
      }
    };
  }
  parseDocument(e) {
    const t = S(e);
    if (!t) throw new Error(`${this.name}: scene document is not valid JSON`);
    return de(t);
  }
  parseDocumentNodes(e, t, n) {
    if (e.nodes.length === 0) return [];
    const s = /* @__PURE__ */ new Map();
    for (let i = 0; i < e.nodes.length; i++) s.set(i, e.nodes[i].name);
    const o = /* @__PURE__ */ new Map();
    for (let i = 0; i < e.nodes.length; i++) {
      const a = e.nodes[i].children;
      if (a) for (const u of a) o.set(u, i);
    }
    const r = [];
    for (let i = 0; i < e.nodes.length; i++) r.push(this.convertNode(e.nodes[i], i, e, s, o, t, n));
    for (const [i, a] of o) r[i] && r[a] && (r[i].parentNode = r[a]);
    return r;
  }
  convertNode(e, t, n, s, o, r, i) {
    const a = e.name || `Node_${t}`, u = {
      translation: e.translation,
      rotation: e.rotation,
      scale: e.scale
    }, f = o.get(t), h = f !== void 0 ? s.get(f) : void 0, c = e.file !== void 0 ? n.files[e.file] : void 0, l = c?.uri, d = Ee(e), m = {
      name: a,
      ...e.uid ? { uid: e.uid } : {},
      originalAssetUri: l,
      ...c?.name ? { srcName: c.name } : {},
      transform: u.translation || u.rotation || u.scale ? u : void 0,
      parentName: h,
      extras: e.extras,
      ...d ? { foreign: d } : {}
    };
    if (e.animationBinding) {
      const _ = e.animationBinding.sources.flatMap((U) => {
        const R = n.files[U.file]?.uri;
        if (R === void 0)
          return v.warn(`[GltfScene] ${a}: TRACE_animation_binding source file ${U.file} not found; source dropped`), [];
        const N = this.resolveFileUri(R, r, i);
        return [{
          src: R,
          ...N.folderUrl ? { folderUrl: N.folderUrl } : {},
          ...U.root !== void 0 ? { root: U.root } : {}
        }];
      });
      _.length > 0 && (m.animationBinding = { sources: _ });
    }
    if (!c || !l) return m;
    const b = this.resolveFileUri(l, r, i);
    m.resolvedSrcUrl = b.folderUrl;
    const p = K(l), x = n.sourceFormat === "gltf21" && e.carrier === "externalAsset" && c.mimeType === "model/gltf+json", A = n.sourceFormat === "gltf21" && X(l) !== null;
    m.sceneRef = p || x || A;
    const y = Me(e.extras) || V(l, W(e.extras)) !== void 0;
    return e.carrier === "externalAsset" && (n.sourceFormat === "glxf" || c.mimeType === "model/gltf-binary" || c.mimeType === "") && !y && !m.sceneRef && (m.assetUri = b.url), m;
  }
  resolveFileUri(e, t, n) {
    if (n) {
      const o = this.extractFilename(e);
      let r = n.get(o);
      if (!r && e.startsWith("assets/")) {
        const i = e.replace(/^assets\//, "");
        r = n.get(i);
      }
      if (r) return { url: r };
    }
    if (Be(e)) return { url: e };
    if (this._externalAssetLookup) {
      const o = this._externalAssetLookup(e);
      if (o) {
        const r = URL.createObjectURL(o);
        return this.trackBlobUrl(r), { url: r };
      }
    }
    const s = $e(e, t);
    return {
      url: s,
      folderUrl: s === e ? void 0 : s
    };
  }
  extractFilename(e) {
    const t = e.replace(/\\/g, "/").split("/");
    return t[t.length - 1] || e;
  }
  async loadNodesWithResult(e, t, n) {
    const s = await ie({
      nodes: e.nodes,
      scene: t,
      onProgress: n,
      loadAsset: (o, r) => this.loadGLBAsset(o, r, t),
      extractMetadata: (o, r) => this.extractNodeMetadata(o, r)
    });
    for (const o of s.nodes) o.assetUri && !o.loadError && (o.assetInstantiated = !0);
    return this.applyDocumentData(s, e);
  }
  extractNodeMetadata(e, t) {
    if (e.originalAssetUri && (t.src = e.originalAssetUri), e.resolvedSrcUrl && (t.srcUrl = e.resolvedSrcUrl), e.srcName && (t.srcName = e.srcName), e.sceneRef && (t.sceneRef = !0), e.uid && (t.uid = e.uid), e.foreign && (t.foreign = e.foreign), e.animationBinding) {
      const s = e.animationBinding.sources;
      t.animationBinding = { sources: s.map(({ src: r, root: i }) => ({
        src: r,
        ...i !== void 0 ? { root: i } : {}
      })) };
      const o = s.flatMap(({ src: r, folderUrl: i }) => i ? [[r, i]] : []);
      o.length > 0 && (t.animationSourceUrls = o);
    }
    const n = e.extras?.trace;
    n && (n.behaviors && (t.behaviors = n.behaviors), n.active !== void 0 && (t.active = n.active));
  }
  async loadNodesIntoContainer(e, t, n, s) {
    return ae({
      nodes: e.nodes,
      container: t,
      scene: n,
      onProgress: s,
      loadAsset: (o, r) => this.loadGLBAsset(o, r, n)
    });
  }
  async loadGLBAsset(e, t, n) {
    let s;
    const o = await ee(e, n, {
      pluginExtension: ".glb",
      pluginOptions: { gltf: {
        animationStartMode: ne.NONE,
        onParsed: (r) => {
          s = r.json.extensionsUsed;
        }
      } }
    });
    if (o.meshes.length > 0) {
      const r = o.meshes[0];
      this.processRootNode(r, t);
    }
    return Object.assign(o, { extensionsUsed: s });
  }
  processRootNode(e, t) {
    return re(e, t);
  }
  applyTransform(e, t) {
    L(e, t);
  }
  trackBlobUrl(e) {
    this._blobUrls.push(e);
  }
  cleanupBlobUrls() {
    for (const e of this._blobUrls) URL.revokeObjectURL(e);
    this._blobUrls = [];
  }
};
function $e(e, t) {
  if (!t) return e;
  try {
    return new URL(e, t).href;
  } catch {
    return t + e;
  }
}
export {
  Xe as a,
  ue as c,
  Ye as d,
  I as f,
  we as i,
  Ke as l,
  $e as n,
  Qe as o,
  ie as p,
  Ze as r,
  he as s,
  et as t,
  le as u
};

//# sourceMappingURL=GltfSceneLoaderPlugin-g47wYMf3.js.map